"use strict";

import { Collection } from "Collection";
import { FormFieldEventsModel } from 'Models/FormFieldEventsModel';
import { Objects } from "Constants/objects";
export var FormFieldEventsCollection = Collection.extend({
  model: FormFieldEventsModel,
  object: Objects.SysFormFieldEvents
});